<template>
  <el-submenu
    ref="subMenu"
    :index="handlePath(item.path)"
    :popper-append-to-body="false"
    :class="{ 'more-menu__submenu': item.name === 'moreMenu' }"
  >
    <template slot="title">
      <!-- <ht-icon
        v-if="item.meta && item.meta.icon"
        :name="item.meta.icon"
        class="ht-fa-icon"
      /> -->
      <template v-if="item.name !== 'moreMenu'">
        <i
          class="ht-fa-icon"
          :class="item.menuIcon || item.meta.icon || 'icon-monitor'"
        />

        <el-tooltip
          v-if="item.meta.title && item.meta.title.length > 5"
          :content="item.meta.title"
          placement="right-end"
        >
          <span class="sub-menu-title">
            {{ item.meta.title }}
            <i v-if="isShowTag" class="new-tag">{{ $t('eip.common.new') }}</i>
          </span>
        </el-tooltip>
        <span v-else class="sub-menu-title">
          {{ item.meta.title }}
          <i v-if="isShowTag" class="new-tag">{{ $t('eip.common.new') }}</i>
        </span>
      </template>
      <i v-else class="icon-gengduo2 more-menu"></i>
    </template>
    <slot />
  </el-submenu>
</template>

<script>
  import { isExternal } from '@/utils/validate'
  import path from 'path'

  export default {
    name: 'HtSubmenu',
    props: {
      routeChildren: {
        type: Object,
        default() {
          return null
        },
      },
      item: {
        type: Object,
        default() {
          return null
        },
      },
      fullPath: {
        type: String,
        default: '',
      },
    },
    computed: {
      isShowTag() {
        const hasIsNewList = this.item?.children?.filter((it) => it.isNew)
        return hasIsNewList && hasIsNewList.length > 0 ? true : false
      },
    },
    methods: {
      handlePath(routePath) {
        if (isExternal(routePath)) {
          return routePath
        }
        if (isExternal(this.fullPath)) {
          return this.fullPath
        }
        return path.resolve(this.fullPath, routePath)
      },
    },
  }
</script>
<style lang="scss" scoped>
  .el-menu-item.is-active {
    .new-tag {
      color: $base-color-white;
    }
  }
  .new-tag {
    display: inline-block;
    margin-left: 4px;
    font-size: $base-font-size-small;
    color: $base-color-white;
    width: 22px;
    height: 16px;
    border-radius: 8px 8px 8px 0;
    text-align: center;
    line-height: 16px;
    background: linear-gradient(90deg, #e55555 0%, #ff9900 100%);
  }
  .more-menu {
    color: #add0ff;
    &:hover {
      color: var(--themeColor);
    }
  }
</style>
